module.exports = __webpack_public_path__ + "da2c37d64071616505e873556b5b5a61.png";